import { Dependencies, DependenciesFactory, FileContentFactory, FileContent } from ".."

export interface CreateAward {
    isDraft: boolean
    isActive: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    image: FileContent
    amount?: number | null
    categoryIds: string[]
    dependencies: Dependencies | null
}

export class CreateAwardFactory {
    static create(): CreateAward {
        return {
            isDraft: false,
            isActive: false,
            names: {
                hr: "",
                en: "",
            },
            descriptions: {
                hr: "",
                en: "",
            },
            image: FileContentFactory.create(),
            amount: null,
            categoryIds: [],
            dependencies: DependenciesFactory.create(),
        }
    }
}
